import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const GithubAiAccesses = {
  // Named to match the gcloud convention: the access key is the grain of access being
  // requested (a set of permissions on a repository); the shared NHI credential that
  // delivers it is an implementation detail.
  permission: Access({
    description:
      "Permissions on a GitHub repository, granted via a shared NHI credential",
    label: "Permission",
    maturity: "beta",
    ...VaultedSecretAccess,
    parameters: {
      organization: {
        type: "dynamic",
        label: "Organization",
        description: "GitHub organization",
      },
      repository: {
        type: "dynamic",
        label: "Repository",
        description: "GitHub repository",
      },
      // Encoded as "<permission>:<level>" (e.g. "contents:write") — see
      // GithubRepositoryPermissionLevels for the full permission model.
      policies: {
        type: "dynamic",
        label: "Policies",
        description: "Permissions to grant on the repository",
        multivalued: true,
      },
    },
    render: {
      locator: "organization",
      policy: "policies",
      resource: "repository",
    } as const,
  }),
};

export type GithubAiAccesses = typeof GithubAiAccesses;
export type GithubAiAccess = GithubAiAccesses[keyof GithubAiAccesses];

export type GithubAiPermissionAccess = GithubAiAccesses["permission"];
